import ReactDOM from 'react-dom'
import React from 'react'
import { SharedProps, SnackbarProvider, useSnackbar } from 'notistack'
import { toast } from 'sonner'

// const CloseButton = (id: number) => {
//   const { closeSnackbar } = useSnackbar();
//   return (
//     <Tooltip title='Fechar'>
//       <IconButton onClick={() => closeSnackbar(id)} edge='end' size='small'>
//         <MdClose color='white'/>
//       </IconButton>
//     </Tooltip>
//   );
// };

export const setAlert = (
  mensagem: string,
  type: SharedProps['variant'],
  time?: number,
): void => {
  const Wrapper = () => {
    const { enqueueSnackbar } = useSnackbar()
    enqueueSnackbar(mensagem, {
      preventDuplicate: false,
      persist: !time,
      autoHideDuration: time,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      variant: type,
    })
    return null
  }
  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(
    <SnackbarProvider maxSnack={5}>
      <Wrapper />
    </SnackbarProvider>,
    document.getElementById('snackbars'),
  )
}

export const setError = (mensagem: string, time?: number): void => {
  toast.error(mensagem, { duration: time })
}
export const setInfo = (mensagem: string, time = 5000): void => {
  toast.info(mensagem, { duration: time })
}
export const setSuccess = (mensagem: string, time = 5000): void => {
  toast.success(mensagem, { duration: time })
}
export const setWarning = (mensagem: string, time = 5000): void => {
  toast.warning(mensagem, { duration: time })
}
